import {Tr} from "@/i18n/i18n";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import Text = Phaser.GameObjects.Text;
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ClanBonusPanel extends Phaser.GameObjects.Container {

    private expSign!: Sprite;
    private expLabel!: Text;
    private defSign!: Sprite;
    private defLabel!: Text;

    private snowSign!: Sprite;
    private snowLabel!: Text;
    private gearSign!: Sprite;
    private gearLabel!: Text;

    private noBonusLabel!: Text;

    private showZeros!: boolean;

    constructor(scene: Phaser.Scene, x: number, y: number, clanExpRatio: number, clanDefenceChance: number, distance: number, gears: number,
                showZeros: boolean) {
        super(scene);
        this.x = x * CU.S;
        this.y = y * CU.S;
        this.showZeros = showZeros;

        let resSize = 32 * CU.S;

        let x0 = -24;

        this.expSign = SpriteUtils.addSprite(scene, x0-94, 0, Keys.IMG_REWARD_EXPERIENCE).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(this.expSign, resSize, resSize);
        this.expLabel = TextUtils.addTextAdvanced(scene, ClanBonusPanel.getExpBonusText(clanExpRatio), this.expSign.x / CU.S + 14, this.expSign.y / CU.S + 2,
            '#eaeaea', 14, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_BOLD);

        resSize = 25 * CU.S;

        this.defSign = SpriteUtils.addSprite(scene, x0-14, 1, Keys.ATLAS_UI, Keys.CLAN_SHIELD).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(this.defSign, resSize, resSize);
        this.defLabel = TextUtils.addTextAdvanced(scene, ClanBonusPanel.getDefBonusText(clanDefenceChance), this.defSign.x / CU.S + 15, this.defSign.y / CU.S + 1,
            '#eaeaea', 14, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_BOLD);

        this.snowSign = SpriteUtils.addSprite(scene, x0+46, 1, Keys.CL_SNOWFLAKE).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(this.snowSign, resSize, resSize);
        this.snowLabel = TextUtils.addTextAdvanced(scene, ClanBonusPanel.getDistanceBonusText(distance), this.snowSign.x / CU.S + 14, this.snowSign.y / CU.S + 2,
            '#eaeaea', 14, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_BOLD);

        this.gearSign = SpriteUtils.addSprite(scene, x0+126, 1, Keys.CL_GEAR_RESOURCE).setOrigin(0.5, 0.5);
        SpriteUtils.setDispSize(this.gearSign, resSize, resSize);
        this.gearLabel = TextUtils.addTextAdvanced(scene, TextUtils.formatMoney(gears), this.gearSign.x / CU.S + 14, this.gearSign.y / CU.S + 2,
            '#eaeaea', 14, 'normal', 500, 'left', 2, Fonts.MYRIADPRO_BOLD);

        this.noBonusLabel = TextUtils.addTextAdvanced(scene, Tr('net.bonusov'), 0, 0,
            '#baaeae', 11, 'normal', 500, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        this.add([this.expSign, this.defSign, this.snowSign, this.gearSign, this.expLabel, this.defLabel, this.snowLabel, this.gearLabel, this.noBonusLabel]);
        this.updateVisibility(clanExpRatio, clanDefenceChance, distance);
    }

    public updateValues(clanExpRatio: number, clanDefenceChance: number, distance: number) {
        if (this.scene.scene.isActive() && this.expLabel && this.defLabel && this.expLabel.active && this.defLabel.active) {
            this.expLabel.setText(ClanBonusPanel.getExpBonusText(clanExpRatio));
            this.defLabel.setText(ClanBonusPanel.getDefBonusText(clanDefenceChance));

            this.updateVisibility(clanExpRatio, clanDefenceChance, distance);
        }
    }

    public updateGears(gears:number) {
        if (this.scene.scene.isActive() && this.gearLabel && this.gearLabel.active) {
            this.gearLabel.setText(TextUtils.formatMoney(gears));
        }
    }

    public updateVisibility(clanExpRatio: number, clanDefenceChance: number, distance: number) {
        let hidden = clanExpRatio <= 1 && clanDefenceChance <= 0 && distance <= 1000000 && !this.showZeros;
        this.expSign.setVisible(!hidden);
        this.expLabel.setVisible(!hidden);
        this.defSign.setVisible(!hidden);
        this.defLabel.setVisible(!hidden);
        this.snowSign.setVisible(!hidden);
        this.snowLabel.setVisible(!hidden);
        this.gearSign.setVisible(!hidden);
        this.gearLabel.setVisible(!hidden);

        this.noBonusLabel.setVisible(hidden);
    }

    private static getExpBonusText(clanExpRatio: number) {
        return '+' + String(Math.round((clanExpRatio - 0.9999) * 100)) + '%';
    }

    private static getDefBonusText(clanDefenceChance: number) {
        return String(Math.round((clanDefenceChance + 0.0001) * 100)) + '%';
    }

    private static getDistanceBonusText(bonus: number) {
        return String(bonus / 10000) + 'km';
    }
}
